
import { ORGANIZATION_NAME, buildPublisherNode, toJsonLd } from '@/utils/seo'

export default {
  name: 'BlogPostingStructuredData',
  props: {
    headline: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    datePublished: {
      type: String,
      required: true,
    },
    dateModified: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'blogposting-structured-data',
          innerHTML: toJsonLd(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return this.url || this.$config.url + this.$route.path
    },
    absoluteImage() {
      if (!this.image) return null
      return this.image.startsWith('http')
        ? this.image
        : `${this.$config.url}${this.image}`
    },
    structuredData() {
      const data = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: this.headline,
        inLanguage: this.$i18n.locale,
        datePublished: this.datePublished,
        dateModified: this.dateModified || this.datePublished,
        author: {
          '@type': 'Organization',
          name: ORGANIZATION_NAME,
          url: this.$config.url,
        },
        publisher: buildPublisherNode(this.$config.url),
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': this.pageUrl,
        },
        url: this.pageUrl,
      }
      if (this.description) {
        data.description = this.description
      }
      if (this.absoluteImage) {
        data.image = this.absoluteImage
      }
      return data
    },
  },
}
